/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Institution (Institution)
 * 
 * 805290001 = Kontakt (Kontakt)
 * 
 * 805290002 = InstitutionundKontakt (Institution und Kontakt)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceAntragsteller {
 Institution = 805290000,
 Kontakt = 805290001,
 InstitutionundKontakt = 805290002
}

marker([
    "Enum.GlobalEnumsAceAntragsteller.Institution",
    "Enum.GlobalEnumsAceAntragsteller.Kontakt",
    "Enum.GlobalEnumsAceAntragsteller.InstitutionundKontakt"
]);

export namespace GlobalEnumsAceAntragsteller
{
    class DataSets
    {
        static GlobalEnumsAceAntragstellerDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Institution", 805290000, "Institution"),
            new EnumValue("Kontakt", 805290001, "Kontakt"),
            new EnumValue("InstitutionundKontakt", 805290002, "Institution und Kontakt"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceAntragstellerDataSet;
    }
}
